export default "__VITE_ASSET__116b609c__"